import React from 'react';

import styled from 'styled-components';

import { CommunityType } from 'types/communities';

const Container = styled.div`
  display: flex;
  line-height: normal;
  flex-direction: column;
`;

const Community = styled.div`
  display: flex;
  align-items: baseline;
  gap: 5px;
`;

const Name = styled.span`
  text-align: justify;
  font-family: var(--font-bold);
  color: var(--text-primary);
`;

const AdditionalInfo = styled.span`
  font-size: 12px;
  white-space: nowrap;
  color: var(--text-secondary);
`;

type Props = {
  community: CommunityType;
  isBaseCommunity?: boolean;
};

const ShopRequestPropagateModalContentListItem = ({ community, isBaseCommunity }: Props) => {
  const isExcludedFromRegularCadence = community.include_in_regular_shop_cadence === false;

  return (
    <Container>
      <Community>
        <Name>{community.name}</Name>
        {isBaseCommunity && (
          <>
          <span>·</span>
            <AdditionalInfo>Base Community</AdditionalInfo>
          </>
        )}
        {isExcludedFromRegularCadence && (
          <>
            <span>·</span>
            <AdditionalInfo>Excluded from regular shop cadence</AdditionalInfo>
          </>
        )}
      </Community>
      <AdditionalInfo>{community.company.name}</AdditionalInfo>
    </Container>
  );
};

export default ShopRequestPropagateModalContentListItem;
